import React, { useEffect, useRef, useState } from "react";
import { IonModal, IonButton} from "@ionic/react";
import "./TermsAndPrivacy.scss";
import { CallcentralLogo } from "../CallcentralLogo/CallcentralLogo";
import { Footer } from "../Footer/Footer";
import {
  TermsAndPrivacyControlModel,
  TermsAndPrivacyParams,
  TermsAndPrivacyResultInterface,
} from "./TermsAndPrivacy.models";
import { termsAndPrivacyService } from "./TermsAndPrivacy.service";
import { TermsAndPrivacyModel } from "../../../models";
import Loader from "../Loader/Loader";
import { utilService } from "../../../services/utilService";
import { useTranslation } from "react-i18next";

const TermsAndPrivacy: React.FC<TermsAndPrivacyControlModel> = (
  props: TermsAndPrivacyControlModel
) => {
  const { t } = useTranslation();
  const listInnerRef = useRef<HTMLDivElement>(null);
  const [accept, setAccept] = useState<boolean>(true);
  const [isLargeSCreen, setIsLargeScreen]: any = useState(true);

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (scrollTop + clientHeight + 50 > scrollHeight && accept) {
        setAccept(false);
      }
    }
  };

  // If the content is short enough that it does not scroll, the user can never
  // reach the bottom and onScroll never fires, leaving Accept disabled forever.
  // Once the content is rendered, enable Accept when there is nothing to scroll.
  const enableIfNotScrollable = () => {
    if (listInnerRef.current) {
      const { scrollHeight, clientHeight } = listInnerRef.current;
      if (scrollHeight <= clientHeight + 50) {
        setAccept(false);
      }
    }
  };

  const [Data, setData] = useState<TermsAndPrivacyModel>();

  const params: TermsAndPrivacyParams = { network: "" };
  useEffect(() => {
    props.type === "terms" ? fetchTerms() : fetchPrivacy();
    checkIfLargeScreen();
  }, []);

  // Enable Accept once content is rendered and there is nothing to scroll. Done
  // here (after Data changes and the commit finishes) rather than via a callback
  // ref, because a child callback ref fires before the parent's listInnerRef is
  // attached, so the ref-based check read a null container and never enabled the
  // button for short documents. A short timeout lets layout settle first.
  useEffect(() => {
    if (!Data) return;
    const id = setTimeout(() => {
      if (listInnerRef.current) {
        const { scrollHeight, clientHeight } = listInnerRef.current;
        if (scrollHeight <= clientHeight + 50) {
          setAccept(false);
        }
      }
    }, 100);
    return () => clearTimeout(id);
  }, [Data]);

  const fetchTerms = async () => {
    const respResult: TermsAndPrivacyResultInterface =
      await termsAndPrivacyService.terms(params);
    respResult.isSuccess
      ? setData(respResult.TermsAndPrivacy)
      : alert(respResult.message);
  };

  const fetchPrivacy = async () => {
    const respResult: TermsAndPrivacyResultInterface =
      await termsAndPrivacyService.privacy(params);
    respResult.isSuccess
      ? setData(respResult.TermsAndPrivacy)
      : alert(respResult.message);
  };

  const checkIfLargeScreen = () => {
    if (utilService.getScreenSize() === "large") {
      setIsLargeScreen(true);
    } else {
      setIsLargeScreen(false);
    }
  };

  return (
    <IonModal
      isOpen={props.showModal}
      className="terms-model"
      backdropDismiss={false}
    >
      <div className="terms-privacy-modal-container">
        <div className="header-container">
          <CallcentralLogo />
        </div>
        <div
          className={`data-container ${
            isLargeSCreen && "data-container-large-screen"
          }`}
          onScroll={onScroll}
          ref={listInnerRef}
        >
          {Data ? (
            <div
              dangerouslySetInnerHTML={{ __html: Data!.content }}
              ref={enableIfNotScrollable}
            />
          ) : (
            <div className="loader-container">
              <Loader></Loader>
            </div>
          )}
        </div>

        {props.page === "login" ? (
          <div className="terms-btn-container">
            <IonButton
              className="button primary-btn ok-btn btn-curved"
              onClick={props.onOk}
            >
              ok
            </IonButton>
          </div>
        ) : (
          <div className="terms-btn-container">
            <IonButton
              className="button secondary-btn ok-btn btn-curved"
              onClick={props.onCancel}
            >
              {t("cancel")}
            </IonButton>

            <IonButton
              className="button primary-btn ok-btn btn-curved"
              onClick={props.onOk}
              disabled={accept}
            >
              Accept
            </IonButton>
          </div>
        )}
        <div className="terms-footer-container">
          <Footer />
        </div>
      </div>
    </IonModal>
  );
};

export default TermsAndPrivacy;
